import { LinksType } from "../SearchFilterResultData";
import { clsx } from "clsx";

type LinksProps = {
  links: LinksType;
  searchTerm: string;
};

export function Links({ links, searchTerm }: LinksProps) {
  if (!links?.length) {
    return null;
  }

  return (
    <ul className="sfr-links">
      {links.map(({ name, url, isActive }) => {
        const href = url + (searchTerm ? `?term=${searchTerm}` : "");

        return (
          <li key={name}>
            <a href={href} className={clsx(isActive && "active")}>
              {name}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
